import { CaptureResult } from "posthog-js"
import type { posthogBrowser } from "src/integrations/posthog/client-browser"
import { posthogRewriteBasePath } from "src/integrations/posthog/rewrites"

export const posthogPublicWriteKey = "phc_pQHv3h1aJtPwOfTsGcUOmlDScwqLvyEcKTtkf9wm7VL"

// https://posthog.com/docs/libraries/js#config
export const posthogOptions: Parameters<typeof posthogBrowser.init>[1] = {
  api_host: posthogRewriteBasePath,
  ui_host: "https://eu.posthog.com",
  person_profiles: "never",
  opt_out_capturing_by_default: true,
  opt_out_persistence_by_default: true,

  // https://posthog.com/docs/libraries/js#redacting-information-in-events
  before_send: (event: CaptureResult | null): CaptureResult | null => {
    if (!event) {
      return null
    }
    return event
  },
}
